const pluralRules = new Intl.PluralRules('ru');

export const formatQuantity = (amount: number, forms: readonly [string, string, string]) => {
  const plural = pluralRules.select(amount);
  const word = plural === 'one' ? forms[0] : plural === 'few' ? forms[1] : forms[2];
  return `${amount.toLocaleString('ru-RU')} ${word}`;
};
